const appAssets={
    resume:'resume/James-Mensah.pdf'
}

export default appAssets;
